import React, { useMemo, useState } from "react";
import ModalSMS from "../components/ModalSMS";
import CustomerTableSMS from "./CustomerTableSMS";

export default function CustomersTablePanelSMS({ customers, onCustomersChange, disabled = false, onNotify }) {
  const [showCustomerDetailsModal, setShowCustomerDetailsModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [customersPage, setCustomersPage] = useState(1);
  const [customersPerPage] = useState(10);

  const list = useMemo(() => (Array.isArray(customers) ? customers : []), [customers]);
  const getTotalCustomers = () => list.length;

  const viewCustomer = (customer) => {
    setSelectedCustomer(customer);
    setShowCustomerDetailsModal(true);
  };

  return (
    <>
      <CustomerTableSMS
        customers={list}
        customersPage={customersPage}
        customersPerPage={customersPerPage}
        getTotalCustomers={getTotalCustomers}
        viewCustomer={viewCustomer}
        setCustomersPage={setCustomersPage}
        setCustomers={onCustomersChange}
        interactionsEnabled={!disabled}
        onNotify={onNotify}
      />

      <ModalSMS
        show={showCustomerDetailsModal}
        maxWidth="700px"
        title="Customer Details"
        onClose={() => {
          setShowCustomerDetailsModal(false);
          setSelectedCustomer(null);
        }}
        body={
          <div style={{ padding: "16px 20px", textAlign: "left", minWidth: 0 }}>
            {!selectedCustomer ? (
              <div className="text-muted">No customer selected.</div>
            ) : (
              <>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "120px 1fr",
                    gap: "8px 16px",
                    alignItems: "baseline",
                    marginBottom: 12,
                  }}
                >
                  <strong style={{ whiteSpace: "nowrap" }}>Name:</strong>
                  <span>{selectedCustomer.name || "N/A"}</span>
                  <strong style={{ whiteSpace: "nowrap" }}>Phone:</strong>
                  <span>{selectedCustomer.phone_number || "N/A"}</span>
                </div>

                {(() => {
                  const df =
                    selectedCustomer.dynamic_variables ||
                    selectedCustomer.dynamicVariables ||
                    selectedCustomer.dynamic_fields ||
                    selectedCustomer.dynamicFields;
                  const dynList = Array.isArray(df)
                    ? df
                    : df && typeof df === "object"
                      ? Object.entries(df).map(([k, v]) => ({ field_name: k, field_value: v }))
                      : [];
                  if (!dynList || dynList.length === 0) return null;
                  return (
                    <div style={{ marginTop: 16 }}>
                      <strong style={{ display: "block", marginBottom: 8 }}>Dynamic Variables</strong>
                      <div style={{ fontSize: "12px", color: "#6c757d", marginBottom: 8, lineHeight: 1.4 }}>
                        Spaces in CSV column names are removed (e.g. &quot;Policy Number&quot; → PolicyNumber). Use{" "}
                        <code style={{ background: "#f1f3f4", padding: "1px 4px", borderRadius: 3 }}>
                          {"{{"}VariableName{"}}"}
                        </code>{" "}
                        in your workspace to insert the value during SMS.
                      </div>
                      <div
                        style={{
                          maxHeight: 260,
                          overflowY: "auto",
                          border: "1px solid #dee2e6",
                          borderRadius: 6,
                          padding: 12,
                        }}
                      >
                        {dynList.map((item, idx) => (
                          <div
                            key={idx}
                            style={{
                              display: "grid",
                              gridTemplateColumns: "minmax(140px, 1fr) minmax(0, 2fr)",
                              gap: "8px 16px",
                              alignItems: "center",
                              borderBottom: idx < dynList.length - 1 ? "1px solid #dee2e6" : "none",
                              paddingBottom: idx < dynList.length - 1 ? 8 : 0,
                              marginBottom: idx < dynList.length - 1 ? 8 : 0,
                            }}
                          >
                            <span style={{ fontWeight: 600, wordBreak: "break-word" }}>
                              {item.field_name || item.name || item.key || "Field"}
                            </span>
                            <span style={{ overflowWrap: "anywhere", wordBreak: "break-word" }}>
                              {item.field_value ?? item.value ?? ""}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })()}
              </>
            )}
          </div>
        }
        footer={
          <div className="modal-footer d-flex justify-content-end gap-2">
            <button
              type="button"
              className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
              onClick={() => {
                setShowCustomerDetailsModal(false);
                setSelectedCustomer(null);
              }}
            >
              <span>Close</span>
            </button>
          </div>
        }
      />
    </>
  );
}

